import { render, staticRenderFns } from "./update-member-data.vue?vue&type=template&id=6de2f397"
import script from "./update-member-data.vue?vue&type=script&lang=ts"
export * from "./update-member-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports